/*
 * File: cell-translation-job-name.ts
 * Created: 2026-01-22
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobName extends BaseTableBodyCell {
    get valueText() {
        return this.value ? String(this.value) : "-";
    }

    get sizeText() {
        const inputFile = this.row?.inputFile ?? null;
        const rawSize = inputFile?.size;

        if (rawSize == null || rawSize === "") return "-";

        if (typeof rawSize === "string") {
            const trimmed = rawSize.trim();
            if (trimmed === "") return "-";
            const parsed = Number(trimmed);
            if (Number.isFinite(parsed)) return formatBytes(parsed);
            return trimmed;
        }

        if (typeof rawSize !== "number") return "-";
        return formatBytes(rawSize);
    }

    get fileIconWrapperClass() {
        const kind = String(this.row?.fileKind ?? "").toUpperCase();
        if (kind === "POWERPOINT") return "icon-ppt";
        if (kind === "EXCEL") return "icon-excel";
        return "icon-word";
    }

    get fileIconClass() {
        const kind = String(this.row?.fileKind ?? "").toUpperCase();
        if (kind === "POWERPOINT") return "fa-file-powerpoint";
        if (kind === "EXCEL") return "fa-file-excel";
        return "fa-file-word";
    }
}

function formatBytes(size: number) {
    if (!Number.isFinite(size) || size <= 0) return "-";
    const mb = size / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(1)} MB`;
    const kb = size / 1024;
    return `${kb.toFixed(1)} KB`;
}
